import { gql } from "@apollo/client";
import { Database } from "@nozbe/watermelondb";
import {
  LayoutNodeDeepNestingFragment,
  LayoutNodeLinkDeepNestingFragment,
  SwapLayoutNodesResultDeepNestingFragment,
} from "@towersystems/roam-common/lib/generated-graphql-fragment";
import {
  LayoutNode as LayoutNodeEntity,
  SwapLayoutNodesInput,
} from "@towersystems/roam-common/lib/generated-types";
import { client } from "../../../apollo";
import { default as LayoutNode } from "../../data/model/LayoutNode";
import { AsyncLayoutActionDefinition } from "../types";
import LayoutNodeModel from "../../data/model/LayoutNode";
import { LayoutNodeFilterDeepNestingFragment } from "@towersystems/roam-common/lib/generated-graphql-fragment";

export const swapLayoutNodesMutation = gql`
  ${LayoutNodeFilterDeepNestingFragment}
  ${LayoutNodeLinkDeepNestingFragment}
  ${LayoutNodeDeepNestingFragment}
  ${SwapLayoutNodesResultDeepNestingFragment}
  mutation SwapLayoutNodes($input: SwapLayoutNodesInput!) {
    swapLayoutNodes(input: $input) {
      ...SwapLayoutNodesResultDeepNesting
    }
  }
`;

export const swapLayoutKeysDefinition = new AsyncLayoutActionDefinition<
  LayoutNodeEntity,
  LayoutNodeModel,
  (
    database: Database,
    swapLayoutNodesInput: SwapLayoutNodesInput
  ) => Promise<any>,
  (swapLayoutNodesInput: SwapLayoutNodesInput) => Promise<any>
>({
  localAction: async (
    database: Database,
    swapLayoutNodesInput: SwapLayoutNodesInput
  ) => {
    const firstNode = await database.collections
      .get<LayoutNode>("layout_nodes")
      .find(swapLayoutNodesInput.firstNodeId);

    const secondNode = await database.collections
      .get<LayoutNode>("layout_nodes")
      .find(swapLayoutNodesInput.secondNodeId);

    const firstNodePosition = firstNode.position;

    await database.write(async () => {
      await database.batch(
        firstNode.prepareUpdate((layoutNode) => {
          layoutNode.position = secondNode.position;
        }),
        secondNode.prepareUpdate((layoutNode) => {
          layoutNode.position = firstNodePosition;
        })
      );
    });
  },
  remoteAction: async (swapLayoutNodesInput: SwapLayoutNodesInput) => {
    return client
      .mutate({
        variables: { input: swapLayoutNodesInput },
        mutation: swapLayoutNodesMutation,
      })
      .then((result) => {
        return result.data?.swapLayoutNodes;
      });
  },
});
